import React from "react"
import "../styles/Profile.css"
class Profile extends React.Component {
  render() {
    return (
        
        <div class="profile flex mt-16 justify-center">
        <div class="flex-shrink-0 rounded-full overflow-hidden mr-24  self-start border border-gray-400 w-40 h-40 shadow-md">
            <img class="profilepic" src='/download.png'
                alt='' />
        </div>
        <div class="flex flex-col">
            <div class="flex items-center">
                <span class="mr-5 text-3xl">wilderness_culture</span>
                <button class="cursor-pointer mr-5 border border-gray-400 rounded text-sm py-1 px-2">Message</button>
                    <button class="cursor-pointer mr-5 border border-gray-400 rounded text-sm py-1 px-2">Follow</button>
        
                    <button class="cursor-pointer mr-5  rounded text-sm py-1 px-2"> <svg id="three-dots-svg" width="30" height="30" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.16668 23.8333C10.1792 23.8333 11 23.0125 11 22C11 20.9875 10.1792 20.1667 9.16668 20.1667C8.15415 20.1667 7.33334 20.9875 7.33334 22C7.33334 23.0125 8.15415 23.8333 9.16668 23.8333Z" fill="#120C35" stroke="#120C35" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M22 23.8333C23.0125 23.8333 23.8333 23.0125 23.8333 22C23.8333 20.9875 23.0125 20.1667 22 20.1667C20.9875 20.1667 20.1667 20.9875 20.1667 22C20.1667 23.0125 20.9875 23.8333 22 23.8333Z" fill="#120C35" stroke="#120C35" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M34.8333 23.8333C35.8459 23.8333 36.6667 23.0125 36.6667 22C36.6667 20.9875 35.8459 20.1667 34.8333 20.1667C33.8208 20.1667 33 20.9875 33 22C33 23.0125 33.8208 23.8333 34.8333 23.8333Z" fill="#120C35" stroke="#120C35" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" />
        </svg></button>
              
            </div>

            <div class="flex mt-6">
                <span class="mr-1 font-semibold">2,435</span>
                <p class="mr-10">posts</p>
                <span class="mr-1 font-semibold">1.8M</span>
                <p class="mr-10">followers</p>
                <span class="mr-1 font-semibold">1000</span>
                <p>following</p>
            </div>

            <span class="mt-6 mb-1 font-semibold">Wilderness Culture</span>
            
        <p>Community of outdoor enthusiasts. Our mission is to inspire outdoor adventure
            while
            <br></br> advocating for wilderness preservation #wildernessculture</p>
            <button className="btn-link" href='https://wildernessculture.com/'>wildernessculture.com</button>

    
    <div class="container mx-auto flex px-40 justify-center mt-10 border-t border-gray-200">
        <div class="flex items-center mr-16 cursor-pointer border-t border-gray-900 py-4"><svg
                class="mr-2 -mt-px w-4"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 1H2C1.45 1 1 1.45 1 2V10C1 10.55 1.45 11 2 11H10C10.55 11 11 10.55 11 10V2C11 1.45 10.55 1 10 1ZM4 10H2V8H4V10ZM4 7H2V5H4V7ZM4 4H2V2H4V4ZM7 10H5V8H7V10ZM7 7H5V5H7V7ZM7 4H5V2H7V4ZM10 10H8V8H10V10ZM10 7H8V5H10V7ZM10 4H8V2H10V4Z"
                    fill="#292929" />
            </svg>
            <span class="-mt-px font-semibold text-xs text-gray-900">POSTS</span>
        </div>
        <div class="flex items-center mr-16 cursor-pointer py-4 text-gray-500"><svg class="mr-2 w-4"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5 3H6.705L8.35 1.355L8 1L6 3L4 1L3.645 1.355L5.295 3H1.5C0.95 3 0.5 3.445 0.5 4V10C0.5 10.55 0.95 11 1.5 11H10.5C11.05 11 11.5 10.55 11.5 10V4C11.5 3.445 11.05 3 10.5 3ZM10.5 10H1.5V4H10.5V10ZM4.5 5V9L8 7L4.5 5Z"
                    fill="currentColor" />
            </svg> 
            <span class="font-semibold text-xs">Reels</span></div>
     
        <div class="flex items-center mr-16 cursor-pointer py-4 text-gray-500"><svg class="mr-2 w-4"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 1C3.515 1 1.5 3.015 1.5 5.5C1.5 7.585 2.92 9.335 4.845 9.845L6 11L7.155 9.845C9.08 9.335 10.5 7.585 10.5 5.5C10.5 3.015 8.485 1 6 1ZM6 2C6.83 2 7.5 2.67 7.5 3.5C7.5 4.33 6.83 5 6 5C5.17 5 4.5 4.33 4.5 3.5C4.5 2.67 5.17 2 6 2ZM6 9.15C4.75 9.15 3.645 8.51 3 7.54C3.015 6.545 5 6 6 6C6.995 6 8.985 6.545 9 7.54C8.355 8.51 7.25 9.15 6 9.15Z"
                    fill="currentColor" />
            </svg>
            <span class="font-semibold text-xs">TAGGED</span></div>
    </div>
{/* </span> */}
</div>
</div>
    )
  }
}
export default Profile









      